var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H40C48.8366 0 56 7.16344 56 16V40C56 48.8366 48.8366 56 40 56H16C7.16344 56 0 48.8366 0 40V16Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.83 18.18C28.5694 18.0611 28.2864 17.9996 28 17.9996C27.7136 17.9996 27.4306 18.0611 27.17 18.18L18.6 22.08C18.4225 22.1582 18.2717 22.2864 18.1658 22.4488C18.0598 22.6113 18.0034 22.8011 18.0034 22.995C18.0034 23.1889 18.0598 23.3787 18.1658 23.5411C18.2717 23.7036 18.4225 23.8317 18.6 23.91L27.18 27.82C27.4406 27.9388 27.7236 28.0003 28.01 28.0003C28.2964 28.0003 28.5794 27.9388 28.84 27.82L37.42 23.92C37.5974 23.8417 37.7483 23.7136 37.8542 23.5511C37.9601 23.3887 38.0165 23.1989 38.0165 23.005C38.0165 22.8111 37.9601 22.6213 37.8542 22.4588C37.7483 22.2964 37.5974 22.1682 37.42 22.09L28.83 18.18Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28C17.9995 28.1913 18.0539 28.3787 18.1567 28.5399C18.2595 28.7012 18.4064 28.8297 18.58 28.91L27.18 32.82C27.4392 32.9374 27.7205 32.9981 28.005 32.9981C28.2895 32.9981 28.5708 32.9374 28.83 32.82L37.41 28.92C37.587 28.8404 37.737 28.7111 37.8418 28.5477C37.9466 28.3844 38.0015 28.1941 38 28",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 33C17.9995 33.1913 18.0539 33.3787 18.1567 33.5399C18.2595 33.7012 18.4064 33.8297 18.58 33.91L27.18 37.82C27.4392 37.9374 27.7205 37.9981 28.005 37.9981C28.2895 37.9981 28.5708 37.9374 28.83 37.82L37.41 33.92C37.587 33.8404 37.737 33.7111 37.8418 33.5477C37.9466 33.3844 38.0015 33.1941 38 33",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/Design.8c85366acbb773b72fe7b6b23b764612.svg";
export { ForwardRef as ReactComponent };